// Flow types automatically removed
/* eslint-disable react/prop-types */

import { Component } from 'react';
import DropZone from 'react-dropzone';
import { ImageUploaderImageRenderer } from './ImageUploaderImageRenderer';
import { DropZoneOverlay } from './DropZoneOverlay';
import Note from 'dibs-icons/exports/legacy/Note';
import Lock from 'dibs-icons/exports/legacy/Lock';
import Download from 'dibs-icons/exports/legacy/Download';
import RotateButton from 'dibs-icons/exports/legacy/ArrowClockwise';
import { Spinner } from 'dibs-elements/exports/Spinner';
import Trash from 'dibs-icons/exports/legacy/TrashCan';
import classNames from 'classnames';
import styles from './styles/ImageUploader.scss';
import { noop } from './utils';

class ImageUploader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDeleteConfirmation: false,
            showOptions: false,
        };
        this.confirmDelete = this.confirmDelete.bind(this);
        this.onHover = this.onHover.bind(this);
        this.toggleDeleteConfirmation = this.toggleDeleteConfirmation.bind(this);
    }

    onHover(isHovering) {
        this.setState({
            showOptions: isHovering,
        });
    }

    toggleDeleteConfirmation(showDeleteConfirmation) {
        this.setState({
            showDeleteConfirmation,
        });
    }

    confirmDelete() {
        const { onDelete } = this.props;
        this.toggleDeleteConfirmation(false);
        onDelete();
    }

    render() {
        const {
            classes,
            displayOverlay,
            dropZoneAccept,
            errorMessage,
            hasCaption,
            imageUploaderIndex,
            isDraggable,
            isPending,
            isPrimary,
            mediaLocation,
            mediaId,
            uploadPending,
            isLocked,
            allowDownload,
            onDownload,
            onDrop,
            onImageClick,
            onImageUploaderDragEnter,
            onImageUploaderDragLeave,
            onRotationChange,
            renderNoMediaPlaceholder,
            mediaType,
            requireDeleteConfirmation,
            allowRotation,
            segmentedView,
            isSelected,
            size,
            openPreviewModal,
            excludePrimaryImage,
            onDelete,
            showActionIcons,
        } = this.props;
        const { showDeleteConfirmation, showOptions } = this.state;
        const isSizeSmall = size === 'small';
        const dropZoneStyle = classNames(
            {
                [styles.primaryDropZone]: isPrimary,
                [classes.hasImage || '']: mediaLocation && classes.hasImage,
                [classes.noImage || '']: !mediaLocation && classes.noImage,
                [classes.isDraggable || '']: mediaLocation && isDraggable && classes.isDraggable,
                [classes.dropZoneSmall || '']: isSizeSmall,
                [classes.noPrimaryImage || '']: excludePrimaryImage,
            },
            classes.dropZone
        );
        const overlayClasses = classNames(styles.overlay, {
            [styles.overlayError]: errorMessage && !uploadPending && !showDeleteConfirmation,
            [styles.overlayPending]: uploadPending && !showDeleteConfirmation,
        });
        const errorMessageClasses = classNames(
            {
                [classes.dropZoneSmall || '']: isSizeSmall,
            },
            styles.errorMessage,
            classes.dropZone,
            classes.errorMessage
        );
        const imageDetailFooterClasses = classNames(
            {
                [styles.primaryImageDetailFooter]: isPrimary,
                [classes.imageDetailFooterSmall || '']: isSizeSmall,
            },
            styles.imageDetailFooter,
            classes.imageDetailFooter
        );
        const onTrashClick = requireDeleteConfirmation
            ? () => this.toggleDeleteConfirmation(true)
            : () => this.props.onDelete();
        const onDropzoneClick =
            (!isPending && !showDeleteConfirmation && onImageClick) || undefined;

        const onRotateClick = () => onRotationChange && onRotationChange(90, mediaId);

        const onDownloadClick = onDownload || undefined;
        const onDeleteClick = !isPending ? onTrashClick : undefined;
        return (
            <div
                className={classNames(styles.container, {
                    [styles.segmented]: segmentedView,
                    [styles.noPrimaryImage]: excludePrimaryImage,
                })}
                onMouseEnter={() => this.onHover(true)}
                onMouseLeave={() => this.onHover(false)}
            >
                <div
                    data-tn="dropzone-wrapper"
                    onClick={onDropzoneClick}
                    onKeyDown={onDropzoneClick}
                    role="button"
                    tabIndex={0}
                >
                    <DropZone
                        accept={dropZoneAccept}
                        onDrop={(!isPending && !showDeleteConfirmation && onDrop) || undefined}
                        noClick
                        onDragEnter={() => onImageUploaderDragEnter(imageUploaderIndex)}
                        onDragLeave={() => onImageUploaderDragLeave(imageUploaderIndex)}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()} className={dropZoneStyle}>
                                <div
                                    className={classNames({
                                        [styles.selectedImageBorder]:
                                            isSelected && !excludePrimaryImage,
                                    })}
                                />
                                <input data-tn="image-upload-input" {...getInputProps()} />
                                <DropZoneOverlay isImageUploaderOverlay visible={displayOverlay} />
                                <div className={overlayClasses}>
                                    {uploadPending ? (
                                        <Spinner size="small" containerClass={styles.spinner} />
                                    ) : null}
                                </div>
                                <ImageUploaderImageRenderer
                                    classes={{
                                        image: classes.image,
                                    }}
                                    isLocked={isLocked}
                                    isPrimary={isPrimary}
                                    mediaLocation={mediaLocation}
                                    mediaType={mediaType}
                                    showDeleteConfirmation={showDeleteConfirmation}
                                    onConfirmDelete={this.confirmDelete}
                                    onHideDeleteConfirmation={() =>
                                        this.toggleDeleteConfirmation(false)
                                    }
                                    renderNoMediaPlaceholder={renderNoMediaPlaceholder}
                                    segmentedView={segmentedView}
                                    isSelected={isSelected}
                                    size={size}
                                    openPreviewModal={openPreviewModal}
                                    onDelete={onDelete}
                                    showActionIcons={showActionIcons}
                                />
                            </div>
                        )}
                    </DropZone>
                </div>
                {!segmentedView && (
                    <div className={imageDetailFooterClasses}>
                        {hasCaption && (
                            <div className={styles.iconWrapper}>
                                <Note className={classNames(styles.captionIcon, styles.icon)} />
                            </div>
                        )}
                        {!isLocked && allowRotation && showOptions && mediaType === 'photo' && (
                            <div
                                className={styles.iconWrapper}
                                onClick={onRotateClick}
                                onKeyDown={onRotateClick}
                                role="button"
                                tabIndex={0}
                            >
                                <RotateButton
                                    className={classNames(styles.rotateIcon, styles.icon)}
                                />
                            </div>
                        )}
                        {!isLocked && allowDownload && showOptions && (
                            <div
                                className={styles.iconWrapper}
                                onClick={onDownloadClick}
                                onKeyDown={onDownloadClick}
                                role="button"
                                tabIndex={0}
                            >
                                <Download
                                    className={classNames(styles.downloadIcon, styles.icon)}
                                />
                            </div>
                        )}
                        {!isLocked && mediaLocation && showOptions && (
                            <div
                                data-tn="delete-image"
                                onClick={onDeleteClick}
                                onKeyDown={onDeleteClick}
                                className={styles.iconWrapper}
                                role="button"
                                tabIndex={0}
                            >
                                <Trash
                                    className={classNames(
                                        {
                                            [styles.trashIconPending]: isPending,
                                            [styles.trashIcon]: !isPending,
                                        },
                                        styles.icon
                                    )}
                                />
                            </div>
                        )}
                        {isLocked && showOptions && (
                            <Lock className={classNames(styles.lockIcon)} />
                        )}
                    </div>
                )}
                {errorMessage ? <p className={errorMessageClasses}>{errorMessage}</p> : null}
            </div>
        );
    }
}

ImageUploader.defaultProps = {
    classes: {},
    dropZoneAccept: 'image/*',
    errorMessage: '',
    hasCaption: false,
    isDraggable: false,
    mediaLocation: '',
    mediaType: 'photo',
    uploadPending: false,
    allowDownload: false,
    isLocked: false,
    allowRotation: false,
    onDelete: noop,
    onDownload: noop,
    onDrop: noop,
    size: 'default',
    renderNoMediaPlaceholder: () => null,
};
export { ImageUploader };
